
import { mapGetters } from 'vuex'
import { classUpDownConverter } from '~/utils'
export default {
    name: 'TwoColumnTable',
    filters: {
        date(value) {
            const formattedDate =
                value &&
                value.substring(0, 4) +
                    '.' +
                    value.substring(4, 6) +
                    '.' +
                    value.substring(6, 8)

            return formattedDate
        },
        withPlusMinusAndPercent(value) {
            if (!value) return ' 0.00 %'

            if (value > 0) return `+${value} %`

            if (value < 0) return `${value} %`

            return value
        },

        withPlusMinus(value) {
            if (!value) return ' 0'

            if (value.substr(0, 1) !== '-') return `+${value}`

            return value
        },

        undefinedProcessor(value) {
            if (!value) return ' 0'

            return value
        },
    },
    props: {
        data: {
            type: Array,
            default: () => {
                return []
            },
        },
        newsItem: Array,
    },
    watch: {
        newsItems() {
            this.sortList()
        },
    },
    data() {
        return {
            renderLength: 10,
            isMore: false,
            sortItems: [],
            getData: [],
        }
    },
    computed: {
        ...mapGetters('search', ['getSupplyData']),
        filteredItems() {
            const slice =
                this.data &&
                this.data.slice(
                    0,
                    this.renderLength ? this.renderLength : this.data.length
                )

            return slice
        },
    },
    methods: {
        moreButton() {
            this.isMore = true
            this.renderLength = 0
        },
        hideButton() {
            this.isMore = false
            this.renderLength = 10
        },
        percent(rate) {
            if (typeof rate !== 'number') return '자료없음'

            const sign = Math.sign(rate)
            let num = Math.abs(rate)
            let text = ''
            num = num / 100
            num = num.toFixed(2)

            text = sign === 1 ? '+ ' : '- '
            text = text + String(num).concat('%')

            return text
        },
        upDownCssApply(value) {
            return classUpDownConverter(value)
        },

        // 내림차순 정렬
        sortList() {
            if (typeof this.newsItems !== 'object' || this.newsItems === null)
                return

            const copyObject = [...this.newsItems]

            const kospiList = copyObject.filter(
                (item) => item[0].TRADING_MARKET0 === 'Y'
            )
            const kosdqList = copyObject.filter(
                (item) => item[0].TRADING_MARKET0 === 'K'
            )

            const kospiListResult = kospiList.sort((a, b) => {
                return b[0].changeRate - a[0].changeRate
            })
            const kosdqListResult = kosdqList.sort((a, b) => {
                return b[0].changeRate - a[0].changeRate
            })
            this.sortItems = kospiListResult.concat(kosdqListResult)
            console.log(this.item)
        },
    },
}
